import React from 'react';
import { PatientCertificationForm } from './components/PatientCertificationForm';

/**
 * Patient Certification Page
 * 
 * 資格確認画面 - Allows entering patient insurance certification data
 * and copying it to the patient edit screen.
 */
const PatientCertificationPage: React.FC = () => {
  return <PatientCertificationForm />;
};

export default PatientCertificationPage;
